import { Settings } from '@/settings';

const key = Settings.tokenKey;
const ACCOUNT_ID_KEY = 'accountId';
const EMAIL_KEY = 'email';
const MOBILE_KEY = 'mobile';
const UID_KEY = 'uid';
const USER_NAME_KEY = 'userName';

const MAIN_LIST_MODE_KEY = 'mainListMode';
const DETAIL_INFO_MODE_KEY = 'detailInfoMode';
const IS_FATHER = 'isFather';
const IS_PICTURE = 'isPicture';

const CT_EXPIRATION_PX = 'expiration';

const UPLOAD_FILE_PREFIX = 'FilePrefix';
const DOWNLOAD_ZIP_PREFIX = 'DownloadZipPrefix';

const CT_ISDIALOG_PX = 'isDialog';

/**
 * token
 */
export function getToken() {
  return sessionStorage.getItem(key);
}
export function setToken(value) {
  return sessionStorage.setItem(key, value);
}
export function removeToken() {
  return sessionStorage.removeItem(key);
}
/**
 * accountId
 */
export function getAccountId() {
  return sessionStorage.getItem(ACCOUNT_ID_KEY);
}
export function setAccountId(value) {
  sessionStorage.setItem(ACCOUNT_ID_KEY, value);
}
export function removeAccountId() {
  sessionStorage.removeItem(ACCOUNT_ID_KEY);
}
/**
 * email
 */
export function getEmail() {
  return sessionStorage.getItem(EMAIL_KEY);
}
export function setEmail(value) {
  sessionStorage.setItem(EMAIL_KEY, value);
}
export function removeEmail() {
  sessionStorage.removeItem(EMAIL_KEY);
}
/**
 * mobile
 */
export function getMobile() {
  return sessionStorage.getItem(MOBILE_KEY);
}
export function setMobile(value) {
  sessionStorage.setItem(MOBILE_KEY, value);
}
export function removeMobile() {
  sessionStorage.removeItem(MOBILE_KEY);
}
/**
 * uid
 */
export function getUid() {
  return sessionStorage.getItem(UID_KEY);
}
export function setUid(value) {
  sessionStorage.setItem(UID_KEY, value);
}
export function removeUid() {
  sessionStorage.removeItem(UID_KEY);
}
/**
 * userName
 */
export function getUserName() {
  return sessionStorage.getItem(USER_NAME_KEY);
}
export function setUserName(value) {
  sessionStorage.setItem(USER_NAME_KEY, value);
}
export function removeUserName() {
  sessionStorage.removeItem(USER_NAME_KEY);
}

/**
 * mainListMode
 */
export function getMainListMode() {
  return sessionStorage.getItem(MAIN_LIST_MODE_KEY);
}
export function setMainListMode(value) {
  sessionStorage.setItem(MAIN_LIST_MODE_KEY, value);
}
export function removeMainListMode() {
  sessionStorage.removeItem(MAIN_LIST_MODE_KEY);
}

/**
 * detailInfoMode
 */
export function getDetailInfoMode() {
  return sessionStorage.getItem(DETAIL_INFO_MODE_KEY);
}
export function setDetailInfoMode(value) {
  sessionStorage.setItem(DETAIL_INFO_MODE_KEY, value);
}
export function removeDetailInfoMode() {
  sessionStorage.removeItem(DETAIL_INFO_MODE_KEY);
}

/**
 * isFather
 */
export function getIsFather() {
  return sessionStorage.getItem(IS_FATHER);
}
export function setIsFather(value) {
  sessionStorage.setItem(IS_FATHER, value);
}
export function removeIsFather() {
  sessionStorage.removeItem(IS_FATHER);
}

/**
 * isPicture
 */
export function getIsPicture() {
  return sessionStorage.getItem(IS_PICTURE);
}
export function setIsPicture(value) {
  sessionStorage.setItem(IS_PICTURE, value);
}
export function removeIsPicture() {
  sessionStorage.removeItem(IS_PICTURE);
}

/**
 * expiration
 */
export function getExpiration() {
  return sessionStorage.getItem(CT_EXPIRATION_PX);
}
export function setExpiration(value) {
  sessionStorage.setItem(CT_EXPIRATION_PX, value);
}
export function removeExpiration() {
  sessionStorage.removeItem(CT_EXPIRATION_PX);
}

/**
 * uploadFilePrefix
 */
export function getUploadFilePrefix(id) {
  return sessionStorage.getItem(`${UPLOAD_FILE_PREFIX}-${id}`);
}
export function setUploadFilePrefix(id, value) {
  sessionStorage.setItem(`${UPLOAD_FILE_PREFIX}-${id}`, value);
}
export function removeUploadFilePrefix(id) {
  sessionStorage.removeItem(`${UPLOAD_FILE_PREFIX}-${id}`);
}
export function getSessionStorageKeysWithString() {
  const matchingArr = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const sessionStorageKey = sessionStorage.key(i);
    if (sessionStorageKey.includes(`${UPLOAD_FILE_PREFIX}-`)) {
      const targetItem = JSON.parse(sessionStorage.getItem(sessionStorageKey));
      matchingArr.push(targetItem);
    }
  }
  return matchingArr;
}

/**
 * downloadZipPrefix
 */
export function getDownloadZipPrefix(id) {
  return sessionStorage.getItem(`${DOWNLOAD_ZIP_PREFIX}-${id}`);
}
export function setDownloadZipPrefix(id, value) {
  sessionStorage.setItem(`${DOWNLOAD_ZIP_PREFIX}-${id}`, value);
}
export function removeDownloadZipPrefix(id) {
  sessionStorage.removeItem(`${DOWNLOAD_ZIP_PREFIX}-${id}`);
}
export function getSessionStorageKeysByDownloadZip() {
  const matchingArr = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const sessionStorageKey = sessionStorage.key(i);
    if (sessionStorageKey.includes(`${DOWNLOAD_ZIP_PREFIX}-`)) {
      const targetItem = JSON.parse(sessionStorage.getItem(sessionStorageKey));
      matchingArr.push(targetItem);
    }
  }
  return matchingArr;
}

/**
 * isDialog
 */
export function getIsDialog() {
  return sessionStorage.getItem(CT_ISDIALOG_PX);
}
export function setIsDialog(value) {
  sessionStorage.setItem(CT_ISDIALOG_PX, value);
}
export function removeIsDialog() {
  sessionStorage.removeItem(CT_ISDIALOG_PX);
}
